module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"company-data":"Dados da empresa","managing-partner":"Sócio {number}"},"en-US":{"company-data":"Company data","managing-partner":"Managing partner {number}"}}')
  delete Component.options._Ctor
}
